import type { QueryClient } from "@tanstack/react-query";

/** Base key for all settings activity log paginated queries (filters are a suffix). */
export const activityLogQueryKeys = {
  all: ["settings-activity-log"] as const,
};

export function invalidateActivityLogQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    queryKey: activityLogQueryKeys.all,
  });
}
